<ng-container *ngIf="!isTouchUi; else mobileSelect">
	<div class="mat-elevation-z3">
		<div class="div-button">
			<button
				*ngFor="let item of customPresets"
				class="custom-range-panel__preset"
				[ngClass]="{ 'custom-range-panel__preset--selected': buttonSelected === item }"
				mat-button
				(click)="selectRange(item)"
			>
				<span>{{ item | translate }}</span>
			</button>
		</div>
	</div>
</ng-container>

<ng-template #mobileSelect>
	<div class="mobile-range-selector">
		<mat-form-field appearance="outline" class="access-line-select w-100">
			<mat-label>{{ 'dashboard.period' | translate }}</mat-label>
			<mat-select [(value)]="buttonSelected" (selectionChange)="selectRange($event.value)">
				<mat-option *ngFor="let item of customPresets" [value]="item">
					{{ item | translate }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
</ng-template>
